import config from '@/config/config';
import * as Linking from 'expo-linking';
import { Platform } from 'react-native';

export const getReportSharePath = (reportId: string): string =>
  `/board/reports/${reportId}`;

const getConfiguredBaseUrl = (): string | null => {
  const rawBaseUrl = config.app.baseUrl;
  if (!rawBaseUrl) {
    return null;
  }

  return rawBaseUrl.replace(/\/+$/, '');
};

export const getReportShareUrl = (reportId: string): string => {
  const path = getReportSharePath(reportId);

  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    return `${window.location.origin}${path}`;
  }

  const configuredBaseUrl = getConfiguredBaseUrl();

  if (configuredBaseUrl) {
    return `${configuredBaseUrl}${path}`;
  }

  return Linking.createURL(path);
};
